import React, { useCallback, useEffect, useState, useRef } from 'react';
import { AiOutlineArrowUp, AiOutlineArrowDown } from 'react-icons/ai';

import { ReactComponent as ArrowLeft } from '../../../assets/icons/ubr_arrow_left.svg';
import { ReactComponent as ArrowRight } from '../../../assets/icons/ubr_arrow_right.svg';
import { ReactComponent as Delete } from '../../../assets/icons/ubr_delete.svg';
import { ReactComponent as Download } from '../../../assets/icons/ubr_download.svg';
import { Layout, Button, Modal, Shimmer } from '../../../components/';
import { useToast } from '../../../hooks/toast';
import { RoutesPaths } from '../../../routes';
import api from '../../../services/api';
import { EndpointsAPI } from '../../../services/Endpoints';
import type {
  ManualData,
  ManualDataDTO,
} from '../../../shared/interfaces/manual';
import PopulateFaqScreens from '../PopulateFaqScreens';
import {
  TableContainer,
  OrderContainer,
  FooterTable,
  PageSize,
  Pagination,
  PaginationButton,
  PaginationItem,
  LoadingData,
  ReactSelectCustom,
} from './stytes';

interface DataProps {
  id: string;
  nomeDaInstrucao: string;
  textoDaInstrucao: string;
  listaDeTelas: [
    {
      id: string;
      titulo: string;
      icone: string;
      subtitulo: string;
      url: string;
    },
  ];
} 

const Lista: React.FC = () => {
  const [data, setData] = useState<ManualData[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [idToDelete, setIdToDelete] = useState<string>('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { addToast } = useToast();
  const sortAscending = useRef(true);

  // Pagination

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setitemsPerPage] = useState(5);
  const [pageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await api.get<ManualDataDTO[]>('/manual');

      const manuais = await PopulateFaqScreens(response.data);
      setData(sortListManual(manuais));

      setIsLoading(false);
    } catch (e) {
      console.error(e);
    }
  }, []);
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const deleteCard = async () => {
    closeModal();

    try {
      const response = await api.delete(`/manual/${idToDelete}`);

      if (response.status === 204 || response.status === 200) {
        addToast({
          type: 'success',
          title: 'Manual excluído com sucesso!',
          description: 'O Manual foi removido.',
        });
        fetchData();
      }

      if (response.status === 500 || response.status === undefined) {
        addToast({
          type: 'error',
          title: 'Erro ao excluir o manual',
          description: `Houve um erro ao excluir o manual de nosso sistema!`,
          time: 6000,
        });
      }
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Erro ao excluir o manual',
        description: `Houve um erro ao excluir o manual de nosso sistema!`,
        time: 6000,
      });
    }
  };

  const openModal = (id: string) => {
    setIdToDelete(id);
    setShowDeleteModal(true);
  };

  const closeModal = () => {
    setShowDeleteModal(false);
  };

  const sortListManual = (manual: ManualData[]): ManualData[] => {
    let orderList = manual.sort(function (a, b): any {
      if (a.tituloArquivo.toUpperCase() < b.tituloArquivo.toUpperCase())
        return -1;
      if (a.tituloArquivo.toUpperCase() > b.tituloArquivo.toUpperCase())
        return 1;
      return 0;
    });
    if (sortAscending.current) {
      return orderList;
    }
    return orderList.reverse();
  };

  const toggleListOrder = () => {
    sortAscending.current = !sortAscending.current;
    const sortedList = sortListManual(data);
    setData([...sortedList]);
  };

  // Baixar PDF

  async function handleDownloadManual(id: string, name: string) {
    const manualPath = EndpointsAPI.baixarManualPorId + id;
    const response = await api.get(manualPath, {
      responseType: 'arraybuffer',
    });
    const url = URL.createObjectURL(
      new Blob([response.data], {
        type: 'application/pdf',
      }),
    );

    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Renderizar a tabela

  const loadingTable = () => {
    return (
      <tr>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <div
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
        <td>
          <ul
            style={{
              width: '100%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </ul>
        </td>
        <td>
          <div
            style={{
              width: '70%',
              height: '40px',
              overflow: 'hidden',
              borderRadius: '4px',
            }}
          >
            <Shimmer />
          </div>
        </td>
      </tr>
    );
  };

  const renderData = (data: DataProps | any) => {
    return (
      <TableContainer>
        <table id="tableData">
          <thead>
            <tr>
              <th style={{ width: '140px' }}>
                <OrderContainer>
                  Manual
                  {sortAscending.current ? (
                    <button onClick={() => toggleListOrder()}>
                      <AiOutlineArrowUp />
                    </button>
                  ) : (
                    <button onClick={() => toggleListOrder()}>
                      <AiOutlineArrowDown />
                    </button>
                  )}
                </OrderContainer>
              </th>
              <th style={{ width: '140px' }}>Arquivo</th>
              <th style={{ width: '250px' }}>Tela</th>
              <th style={{ width: '200px' }}>Ações</th>
            </tr>
          </thead>
          {isLoading ? (
            <tbody>
              {loadingTable()}
              {loadingTable()}
              {loadingTable()}
            </tbody>
          ) : !data.length ? (
            <LoadingData> Sem dados para exibir... </LoadingData>
          ) : (
            <tbody>
              {data.map((todo: any, index: number) => (
                <tr key={index}>
                  <td data-column="Manual">
                    <p>{todo.tituloArquivo}</p>
                  </td>
                  <td data-column="Arquivo">
                    <span>{todo.nomeManual}</span>
                  </td>
                  <td data-column="Tela">
                    <ul>
                      {todo && todo.listaDeTelas
                        ? todo.listaDeTelas.map((screen: any, index: any) => {
                            return <li key={index}>{screen.titulo}</li>;
                          })
                        : ''}
                    </ul>
                  </td>
                  <td data-column="Ações">
                    <div>
                      <Button
                        color={'#C71F37'}
                        variant="solid-icon"
                        onClick={() =>
                          setTimeout(() => {
                            openModal(todo.id);
                          }, 500)
                        }
                        tooltipText={'Excluir'}
                      >
                        <Delete style={{ width: '20px' }} />
                      </Button>
                      <Button
                        variant="solid-icon"
                        onClick={() =>
                          setTimeout(() => {
                            handleDownloadManual(todo.id, todo.nomeManual);
                          }, 500)
                        }
                        tooltipText={'Download do Manual'}
                      >
                        <Download style={{ width: '20px' }} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </TableContainer>
    );
  };

  // Funções para realização da paginação

  const handleClick = (event: any) => {
    setCurrentPage(Number(event.target.id));
  };

  const pages = [];
  for (let i = 1; i <= Math.ceil(data.length / itemsPerPage); i++) {
    pages.push(i);
  }

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const renderPageNumbers = pages.map((number: any) => {
    if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
      return (
        <PaginationItem
          key={number}
          id={number}
          onClick={handleClick}
          aria-hidden={typeof number !== 'number' ? 'true' : 'false'}
          aria-label={`${
            typeof number !== 'number' ? '' : `Ir para a página ${number}`
          }`}
          aria-current={number === currentPage}
          style={
            currentPage === number
              ? { border: '1px solid #ab934b', color: '#ab934b' }
              : undefined
          }
        >
          {number}
        </PaginationItem>
      );
    } else {
      return null;
    }
  });

  const handleNextbtn = () => {
    setCurrentPage(currentPage + 1);

    if (currentPage + 1 > maxPageNumberLimit) {
      setmaxPageNumberLimit(maxPageNumberLimit + pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit + pageNumberLimit);
    }
  };

  const handlePrevbtn = () => {
    setCurrentPage(currentPage - 1);

    if ((currentPage - 1) % pageNumberLimit === 0) {
      setmaxPageNumberLimit(maxPageNumberLimit - pageNumberLimit);
      setminPageNumberLimit(minPageNumberLimit - pageNumberLimit);
    }
  };

  let pageIncrementBtn = null;
  if (pages.length > maxPageNumberLimit) {
    pageIncrementBtn = (
      <PaginationItem onClick={handleNextbtn}> &hellip; </PaginationItem>
    );
  }

  let pageDecrementBtn = null;
  if (minPageNumberLimit >= 1) {
    pageDecrementBtn = (
      <PaginationItem onClick={handlePrevbtn}> &hellip; </PaginationItem>
    );
  }

  const limits = useCallback(e => {
    setitemsPerPage(e.value);
    setCurrentPage(1);
  }, []);

  const options = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 50, label: 50 },
  ];

  // =========================================================================================

  return (
    <>
      <Modal
        show={showDeleteModal}
        titulo={'Excluir Manual'}
        mensagem={'Confirma a exclusão do Manual?'}
        onConfirm={() => deleteCard()}
        onCancel={() => closeModal()}
        actionButtons
      />
      <Layout
        title={'Lista de Manuais'}
        buttonTitle={'Novo Manual'}
        buttonRedirect={RoutesPaths.registerManual}
      >
        {renderData(currentItems)}
        <FooterTable>
          <PageSize>
            Dados por página
            <ReactSelectCustom
              classNamePrefix="react-select"
              onChange={limits}
              options={options}
              defaultValue={itemsPerPage}
              placeholder={5}
              isSearchable={false}
            />
          </PageSize>
          <Pagination>
            <PaginationButton aria-label="Paginação">
              <PaginationItem
                onClick={handlePrevbtn}
                disabled={
                  currentPage === pages[0]
                    ? true
                    : false || pages.length <= 1
                    ? true
                    : false
                }
                aria-label={`Voltar ${
                  currentPage === 1
                    ? 'página'
                    : `para página ${currentPage - 1}`
                }`}
                tabIndex={currentPage === pages[pages.length - 1] ? -1 : 0}
                aria-disabled={
                  currentPage === pages[pages.length - 1] ? 'true' : 'false'
                }
              >
                <ArrowLeft />
              </PaginationItem>
              {pageDecrementBtn}
              {renderPageNumbers}
              {pageIncrementBtn}
              <PaginationItem
                onClick={handleNextbtn}
                disabled={
                  currentPage === pages[pages.length - 1]
                    ? true
                    : false || pages.length <= 1
                    ? true
                    : false
                }
                aria-label={`Avançar ${
                  currentPage === pages[pages.length - 1]
                    ? 'página'
                    : `para página ${currentPage + 1}`
                }`}
                tabIndex={currentPage === pages[pages.length - 1] ? -1 : 0}
                aria-disabled={
                  currentPage === pages[pages.length - 1] ? 'true' : 'false'
                }
              >
                <ArrowRight />
              </PaginationItem>
            </PaginationButton>
          </Pagination>
        </FooterTable>
      </Layout>
    </>
  );
};

export default Lista;
